import { styled } from '@porsche-code/kado-styled-system/jsx';
import { Modal } from '@porsche-code/kado-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { NAMESPACES } from '@/config/i18n';

import { UserFeedbackForm } from './UserFeedbackForm';

const UserFeedbackTab = styled('button', {
  base: {
    position: 'fixed',
    left: '-5px',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'background.canvas',
    border: '1px solid',
    borderLeft: 'none',
    paddingBlock: 'md',
    paddingInline: 'lg',
    cursor: 'pointer',
    writingMode: 'vertical-rl',
    borderRadius: '2xl',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    zIndex: 100,
    fontWeight: 'bold',
    fontSize: 'sm',
    transition: 'all 0.2s',
    '&:hover': {
      left: 0,
      shadow: 'sm',
    },
  },
});

export const UserFeedback = () => {
  const { t } = useTranslation(NAMESPACES);

  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  return (
    <>
      <UserFeedbackTab onClick={() => setIsFeedbackModalOpen(true)}>
        {t('userFeedback.form.feedback')}
      </UserFeedbackTab>
      <Modal
        open={isFeedbackModalOpen}
        onDismiss={() => setIsFeedbackModalOpen(false)}
        backdrop="shading"
      >
        <UserFeedbackForm onDismiss={() => setIsFeedbackModalOpen(false)} />
      </Modal>
    </>
  );
};
